import { Outlet } from 'react-router-dom'

import SettingsLayout from 'src/features/settings/layouts/settings-layout'
import useBreakpoint from 'src/shared/hooks/use-breakpoint'

import EnterpriseSidebarNav from './enterprise-sidebar-nav'

const EnterpriseSettingsLayout = () => {
  const { isMobile } = useBreakpoint()

  if (isMobile) {
    return (
      <div className="flex min-h-screen w-full bg-white">
        <Outlet />
      </div>
    )
  }

  return <SettingsLayout sidebarContent={<EnterpriseSidebarNav />} />
}

export default EnterpriseSettingsLayout
